import script from "./BodorNext.vue?vue&type=script&setup=true&lang=js"
export * from "./BodorNext.vue?vue&type=script&setup=true&lang=js"

import "./BodorNext.vue?vue&type=style&index=0&id=2ec64608&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ec64608"]])

export default __exports__